import Styles from './ToolTip.module.scss';
import React, { JSX, useRef, useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { isTouchScreen, viewport } from '../../utils/utils';
import { AssetPathPropConfig } from '../../services/LineTableBasicPropConfig';

const ToolTip = ({ content, heading = '', tooltipClass = '', isBenefit = false, variant = 'default' }: any): JSX.Element => {
  const viewPort = viewport();
  const touchDevice = isTouchScreen();
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();
  const triggerRef = useRef<HTMLDivElement | null>(null);

  const isError = variant === 'error';
  // Error tooltip (rewards not-eligible) is controlled so the close (X) icon inside
  // the popover header can dismiss it and the trigger icon can toggle it on click.
  // Default variant keeps the original hover/click UX untouched.
  const [show, setShow] = useState<boolean>(false);
  const defaultTrigger: any =
    viewPort === 'mobile' || viewPort === 'tablet' || touchDevice ? 'click' : 'hover';
  // For the error variant we force click-only so the X button can reliably close it
  // (hover would immediately reopen when the pointer is still over the icon).
  const trigger: any = isError ? 'click' : defaultTrigger;

  // Error variant renders a two-column layout: warning icon on the left, and the
  // title+body content (usually authored as a single RichText block) on the right.
  // The close (X) icon is absolutely positioned in the top-right corner.
  const errorBody = isError && (
    <div className={Styles.errorPopoverLayout}>
      {assetPath && (
        <img
          src={`${assetPath}/icons/tooltip-warning-icon.svg`}
          width={24}
          height={24}
          alt=''
          className={Styles.errorPopoverWarningIcon}
        />
      )}
      <div className={Styles.errorPopoverContent}>
        {heading !== '' && <div className={Styles.errorPopoverHeaderText}>{heading}</div>}
        <div>{content}</div>
      </div>
      <button
        type='button'
        aria-label='Close'
        className={Styles.errorPopoverCloseBtn}
        onClick={(e) => {
          e.stopPropagation();
          setShow(false);
        }}
      >
        {/* inline SVG avoids the gray background present in cross_disabled.svg */}
        <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path fillRule='evenodd' clipRule='evenodd' d='M0.21967 0.21967C0.512563 -0.0732233 0.987437 -0.0732233 1.28033 0.21967L6.75 5.68934L12.2197 0.21967C12.5126 -0.0732233 12.9874 -0.0732233 13.2803 0.21967C13.5732 0.512563 13.5732 0.987437 13.2803 1.28033L7.81066 6.75L13.2803 12.2197C13.5732 12.5126 13.5732 12.9874 13.2803 13.2803C12.9874 13.5732 12.5126 13.5732 12.2197 13.2803L6.75 7.81066L1.28033 13.2803C0.987437 13.5732 0.512563 13.5732 0.21967 13.2803C-0.0732233 12.9874 -0.0732233 12.5126 0.21967 12.2197L5.68934 6.75L0.21967 1.28033C-0.0732233 0.987437 -0.0732233 0.512563 0.21967 0.21967Z' fill='white' />
        </svg>
      </button>
    </div>
  );

  const controlledProps = isError
    ? {
        show,
        onToggle: (nextShow: boolean) => setShow(nextShow)
      }
    : {};

  return (
    content && (
      <OverlayTrigger
        placement='auto'
        rootClose
        trigger={trigger}
        {...controlledProps}
        overlay={
          content && (
            <Popover id='popover-basic' className={isError ? Styles.errorPopover : ''}>
              {isError ? (
                <Popover.Body>{errorBody}</Popover.Body>
              ) : (
                <>
                  {heading !== '' && <Popover.Header>{heading}</Popover.Header>}
                  <Popover.Body>{content}</Popover.Body>
                </>
              )}
            </Popover>
          )
        }
      >
        <div
          ref={triggerRef}
          className={`${Styles.tooltipicon} ${tooltipClass} ${isBenefit ? Styles.benefits : ''} ${isError ? Styles.errorTrigger : ''}`}
        >
          {isError
            ? assetPath && <img src={`${assetPath}/icons/red-info-icon.svg`} width={20} height={20} alt='' />
            : assetPath && <img src={`${assetPath}/icons/tooltip_icon.svg`} width={24} height={24} alt='' />}
        </div>
      </OverlayTrigger>
    )
  );
};
export default ToolTip;
